import { createContext, useEffect, useState, useContext } from "react";
import { INTEGRATION_URL } from "../../utils/constants";
import { apifetch } from "../../utils";
import { toLower } from "ramda";

const ProductContext = createContext({});

const ProductProvider = ({ product, children }) => {
  const [offers, setOffers] = useState();
  const [loading, setLoading] = useState(true);
  const [defaultOffer, setDefaultOffer] = useState(null);

  useEffect(() => {
    const url = `${INTEGRATION_URL}/fetchProductOffers?name=${product}`;
    apifetch(url)
      .then(json => {
        if (json) {
          let productOffers = json.offerList ? json.offerList : [];
          setOffers(productOffers);
          setLoading(false);
        }
      })
      .catch(err => {
        setLoading(false);
      });
  }, [product]);

  useEffect(() => {
    const defaultOffer = offers
      ? offers.find(offer => toLower(offer.name) == "premium") || offers[0]
      : null;
    setDefaultOffer(defaultOffer);
  }, [offers]);

  return (
    <ProductContext.Provider value={{ offers, loading, defaultOffer }}>
      {children}
    </ProductContext.Provider>
  );
};

export const useProductContext = () => {
  const productContext = useContext(ProductContext);
  if (productContext === undefined) {
    throw new Error("useContext must be used inside a UserProvider");
  }
  return productContext;
};

export default ProductProvider;
